import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { ConfirmDeleteRasComponent } from '../../confirm-delete-ras/confirm-delete-ras.component';
import {
  evidence,
  hypothesis,
  value,
} from '../register-hypothesis-ras.component';

@Component({
  selector: 'hypothesis-values-form-ras',
  templateUrl: './hypothesis-values-form-ras.component.html',
  styleUrls: ['./hypothesis-values-form-ras.component.scss'],
})
export class HypothesisValuesFormRasComponent implements OnInit {
  @Input() evidences: evidence[];
  @Output() evidencesChange = new EventEmitter<evidence[]>();

  @Input() hypothesis: hypothesis[];
  @Output() hypothesisChange = new EventEmitter<hypothesis[]>();

  @Input() values: value[];
  @Output() valuesChange = new EventEmitter<value[]>();

  constructor(private readonly dialog: MatDialog) {}

  ngOnInit() {}

  getValue(evidence, hypothesis) {
    let value = this.values.find((item) => {
      return item.evidence === evidence && item.hypothesis === hypothesis;
    });
    return !value ? 'N/A' : value.value;
  }

  setValue(value: string, hypothesis: number, evidence: number) {
    const index = this.values.findIndex((item) => {
      return item.evidence === evidence && item.hypothesis === hypothesis;
    });

    if (index === -1) {
      const newValue: value = {
        evidence,
        hypothesis,
        value,
      };
      this.values.push(newValue);
    } else {
      this.values[index].value = value;
    }
    this.valuesChange.emit(this.values);
    this.changeValues.emit();
  }

  $editHypothes = new Subject<hypothesis>();

  editHypothesys(hypothesis) {
    this.$editHypothes.next(hypothesis);
  }

  $editEvidence = new Subject<evidence>();

  editEvidence(evidence) {
    this.$editEvidence.next(evidence);
  }

  @Output() changeValues = new EventEmitter();

  confirmDialog(title: string) {
    return new Promise((resolve) => {
      this.dialog
        .open(ConfirmDeleteRasComponent, {
          data: { title },
        })
        .afterClosed()
        .subscribe({
          next: (result) => {
            resolve(result);
          },
        });
    });
  }

  async deleteHypothesys(hypothesis: hypothesis) {
    const result = await this.confirmDialog(
      '¿Esta seguro de eliminar esta hipótesis?'
    );
    if (result == true) {
      // delete hypothesis
      const index = this.hypothesis.findIndex(
        (item) => item.id === hypothesis.id
      );
      this.hypothesis.splice(index, 1);
      this.hypothesisChange.emit(this.hypothesis);
      this.changeValues.emit();
    }
  }
  async deleteEvidence(evidence: evidence) {
    const result = await this.confirmDialog(
      '¿Esta seguro de eliminar esta evidencia?'
    );
    if (result) {
      // delete evidence
      const index = this.evidences.findIndex((item) => item.id === evidence.id);
      this.evidences.splice(index, 1);
      this.evidencesChange.emit(this.evidences);
      this.changeValues.emit();
    }
  }
}
